import { assert } from '@sparkdotfi/common-universal'

// @note: only allowed value here is 'true' a function or nested object
// actual value of data test id (string) is generated based on a path in the object tree
// functions are automatically prefixed with a path in the object tree
export const testIds = makeTestIds({
  component: {
    MultiAssetSelector: {
      group: true,
    },
    AssetSelector: {
      trigger: true,
      option: true,
    },
    HealthFactorBadge: {
      value: true,
    },
    HealthFactorPanel: {
      gauge: true,
      liquidationPrice: true,
    },
    AssetInput: {
      input: true,
      inputUsdValue: true,
      error: true,
      maxButton: true,
      maxButtonValue: true,
    },
    Alert: {
      message: true,
    },
    DataTable: {
      row: (index: number) => index,
    },
    RiskAcknowledgement: {
      switch: true,
      explanation: true,
    },
    EModeButton: true,
    EModeBadge: true,
    SuccessView: {
      content: true,
      row: (index: number) => index,
      tokenRow: {
        token: true,
        amount: true,
        amountUSD: true,
      },
    },
    AddressInput: {
      input: true,
      error: true,
    },
    ScrollArea: true,
    ConvertStablesPanel: true,
    ConvertStablesButton: true,
    SwitchNotSupportedNetworkButton: true,
    ConnectOrSandboxCTAPanel: true,
    TopbarWalletButton: true,
    TopbarMenu: {
      button: true,
      watchWalletMenuItem: true,
      watchWalletMenuSwitch: true,
    },
    TopbarWallet: {
      disconnectButton: true,
      exitWatchWalletModeButton: true,
    },
  },
  easyBorrow: {
    form: {
      deposits: true,
      borrow: true,
      borrowRate: true,
      ltv: true,
      usdsBorrowAlert: true,
    },
    success: {
      deposited: true,
      borrowed: true,
    },
  },
  myPortfolio: {
    deposited: true,
    borrowed: true,
    depositDialog: {
      newTokenBalance: true,
      newUSDBalance: true,
    },
    supplyAPY: (index: number) => index,
    borrowAPY: (index: number) => index,
  },
  savings: {
    navigation: {
      container: true,
      item: true,
      itemLabel: true,
      itemBalance: true,
    },
    upgradeSDaiBanner: true,
    supportedAssets: {
      moreDropdown: true,
    },
    account: {
      depositCTA: {
        panel: true,
        apy: true,
      },
      mainPanel: {
        container: true,
        apy: true,
        oneYearProjection: true,
      },
      savingsToken: {
        balance: true,
        balanceInUnderlyingToken: true,
      },
    },
  },
  dialog: {
    transactionOverview: {
      routeItem: {
        tokenWithAmount: (index: number) => index,
        tokenUsdValue: (index: number) => index,
      },
      skyBadge: true,
      outcome: true,
      outcomeUsd: true,
      minimumReceived: true,
      minimumReceivedUsd: true,
      usdsWithdrawn: true,
      usdsWithdrawnUsd: true,
    },
    healthFactor: {
      before: true,
      after: true,
    },
    closeButton: true,
    overlay: true,
    success: true,
    savings: {
      transactionOverview: {
        apy: {
          value: true,
          description: true,
        },
        apyChange: {
          before: true,
          after: true,
        },
        balanceBefore: true,
        balanceAfter: true,
        outcome: true,
        slippage: true,
        withdrawn: true,
      },
      send: {
        addressIsSmartContractWarning: true,
      },
      upgradeSwitch: true,
      upgradeDetailsTrigger: true,
      withdraw: {
        success: {
          withdrawnAmount: true,
          receivedAmount: true,
        },
      },
      deposit: {
        success: {
          depositedAmount: true,
          spentAmount: true,
        },
        boostAirdropFormFooter: {
          minDepositButton: true,
        },
      },
      welcomeStusds: {
        lockstakeLtv: true,
        liquidationEnabled: true,
        skyMaxPriceCap: true,
        okButton: true,
      },
    },

    claimRewards: {
      transactionOverview: {
        row: (index: number) => index,
        token: true,
        amount: true,
        amountUSD: true,
      },
    },
    eMode: {
      transactionOverview: {
        availableAssets: {
          category: true,
          assets: true,
        },
        maxLtv: {
          before: true,
          after: true,
        },
      },
    },
    deposit: {
      supplyApyBefore: true,
      supplyApyAfter: true,
    },
    borrow: {
      borrowApyBefore: true,
      borrowApyAfter: true,
      success: {
        borrowed: true,
        swappedFrom: true,
        swappedTo: true,
      },
    },
    repay: {
      success: {
        repaid: true,
        swappedFrom: true,
        swappedTo: true,
      },
    },
    delegate: {
      delegateButton: true,
      success: {
        transactionOverview: {
          staked: true,
          delegateTo: {
            name: true,
            address: true,
          },
          noDelegationText: true,
        },
        proceedButton: true,
      },
      skipButton: true,
    },
    watchWallet: {
      dialog: true,
      enableButton: true,
    },
  },
  actions: {
    settings: {
      dialog: true,
      preferPermitsSwitch: true,
      slippage: {
        error: true,
      },
    },
    row: (index: number) => index,
  },
  topbar: {
    airdrop: {
      badge: true,
      dropdown: true,
    },
    rewards: {
      badge: true,
      claimableRewards: true,
      details: {
        row: (index: number) => index,
        token: true,
        amount: true,
        amountUSD: true,
        dropdown: true,
      },
    },
  },
  markets: {
    summary: {
      tile: (index: number) => index,
    },
    table: {
      active: true,
      frozen: true,
      cell: {
        asset: true,
        totalSupplied: true,
        depositAPY: true,
        totalBorrowed: true,
        borrowAPY: true,
        status: true,
      },
    },
    frozenPill: true,
    pausedPill: true,
    sllManagedPill: true,
    rewardBadge: true,
    airdropBadge: true,
    frozenAssetsSwitch: true,
  },
  marketDetails: {
    collateralStatusPanel: {
      debt: true,
      debtCeiling: true,
    },
    walletPanel: {
      balance: true,
    },
    supplyStatusPanel: {
      cap: true,
      instantlyAvailableToSupply: true,
    },
    borrowStatusPanel: {
      cap: true,
      liquidity: true,
    },
    capAutomator: {
      cooldownTimer: true,
    },
    oraclePanel: {
      asset: true,
      price: true,
      oracleContract: true,
      providersList: true,
      yieldingFixed: {
        ratio: true,
        ratioContract: true,
        baseAssetSymbol: true,
        baseAssetPrice: true,
        baseAssetOracleContract: true,
      },
    },
  },
  farms: {
    active: {
      tile: (index: number) => index,
    },
    inactive: {
      tile: (index: number) => index,
    },
    tile: {
      apy: true,
      stakeText: true,
      rewardText: true,
      staked: true,
    },
  },
  farmDetails: {
    stakeDialog: {
      transactionOverview: {
        estimatedRewards: {
          apy: true,
          description: true,
        },
        route: {
          destination: {
            farmName: true,
            stakingToken: true,
          },
        },
        outcome: true,
        outcomeUsd: true,
      },
    },
    unstakeDialog: {
      transactionOverview: {
        route: {
          farm: {
            farmName: true,
            stakingToken: true,
          },
        },
        outcome: true,
        outcomeUsd: true,
        rewardOutcome: true,
        rewardOutcomeUsd: true,
      },
      exitFarmSwitchPanel: {
        switch: true,
        reward: true,
      },
    },
    claimDialog: {
      transactionOverview: {
        rewardTokenSymbol: true,
        rewardTokenDescription: true,
        rewardAmount: true,
        rewardAmountUSD: true,
      },
    },
    infoPanel: {
      panel: true,
      stakeButton: true,
    },
    activeFarmInfoPanel: {
      rewards: true,
      rewardsUsd: true,
      unstakeButton: true,
      claimButton: true,
      staked: true,
      pointsSyncWarning: true,
    },
  },
  spkFarm: {
    depositCtaPanel: {
      panel: true,
      stakeButton: true,
    },
    activeFarmPanel: {
      stakeButton: true,
      rewards: true,
      rewardsUsd: true,
      unstakeButton: true,
      claimButton: true,
      staked: true,
      pointsSyncWarning: true,
    },
  },
  sparkRewards: {
    claimableRewardsPanel: {
      amountToClaim: true,
    },
    ongoingCampaignsPanel: {
      row: (index: number) => index,
      startButton: true,
    },
  },
  spkStaking: {
    ctaPanel: {
      stakeButton: true,
    },
    rewardsPanel: {
      stakeButton: true,
      staked: true,
      rewards: true,
      unstakeButton: true,
      claimButton: true,
      availableToClaim: true,
    },
    stakeDialog: {
      transactionOverview: {
        estimatedRewards: {
          apy: true,
          description: true,
        },
        unstakingDelay: true,
      },
      success: {
        proceedButton: true,
      },
    },
    unstakeDialog: {
      transactionOverview: {
        claimableOn: true,
      },
    },
    finalizeUnstakeDialog: {
      transactionOverview: {
        amount: true,
        amountUSD: true,
      },
    },
    claimRewardsDialog: {
      transactionOverview: {
        rewardAmount: true,
        rewardAmountUSD: true,
      },
    },
  },
  points: {
    referralInput: {
      input: true,
      error: true,
    },
    earningPanel: {
      row: (index: number) => index,
      amount: true,
      details: true,
    },
    convertPointsPanel: {
      container: true,
      claimedSpk: true,
    },
    convertPointsDialog: {
      transactionOverview: {
        conversionRate: {
          pointsAmount: true,
          spkAmount: true,
        },
        pointsEarned: true,
        season: true,
      },
    },
  },
  spkAirdrop: {
    eligibilityCheckResultPanel: {
      evmAddress: true,
      totalAllocation: true,
    },
    eligibilityBreakdown: {
      item: (index: number) => index,
      title: true,
      amount: true,
      subItem: (index: number) => index,
      subItemTitle: true,
      subItemAmount: true,
    },
    dashboard: {
      summary: {
        totalAllocation: true,
        totalClaimedAllocation: true,
        totalExpiredAllocation: true,
      },
      sidePanel: {
        spkAmount: true,
        spkAmountUsd: true,
        stakedAmount: true,
        pendingAmount: true,
        claimOverdriveButton: true,
      },
    },
  },
  spkGovernance: {
    activeProposalsPanel: {
      table: true,
      title: true,
      votes: true,
      start: true,
      end: true,
      link: true,
    },
    votingPowerDelegationPanel: {
      delegateButton: true,
      moreDropdown: true,
      undelegateButton: true,
      delegateAddress: true,
      delegatedVotingPower: true,
      noDelegationDelegateButton: true,
      noDelegationConnectWalletButton: true,
    },
    myVotingPowerSidePanel: {
      votingPower: true,
      stakedSpk: true,
      spkBalance: true,
      delegateButton: true,
      stakeSpkButton: true,
    },
    noActiveProposalsPanel: {
      message: true,
      description: true,
      followSnapshotButton: true,
    },
  },
})

function makeTestIds<T extends Object>(obj: T, prefix?: string): MapValuesToString<T> {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      const newPrefix = prefix ? `${prefix}-${key}` : key
      if (typeof value === 'object') {
        return [key, makeTestIds(value, newPrefix)]
      }
      if (typeof value === 'function') {
        return [key, (...args: any) => `${newPrefix}-${value(...args)}`]
      }
      assert(value === true, "testIds value map has to be 'true', a function or another nested object")
      return [key, newPrefix]
    }),
  ) as any
}

type MapValuesToString<T> = {
  [K in keyof T]: T[K] extends boolean
    ? string
    : T[K] extends (...args: any[]) => any
      ? (...args: Parameters<T[K]>) => string
      : MapValuesToString<T[K]>
}
